<div style="width: 500px; height: 600px;" data-cy="select-dialog-container">
    <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="select-dialog-section">
        <div class="section-header" style="flex-basis: 30px;" data-cy="select-dialog-header">
            <div class="section-header-title" data-cy="select-dialog-title">
                {{tableTitle}}
            </div>
            <div style="flex: 1;"></div>
        </div>
        <!--  MAIN AREA-->
        <div class="section-content" style="flex: 1;max-height: 510px;" data-cy="select-dialog-content">
            <tdo-table [isSearchable]="isSearchable" [dataSource]="items" (rowSelected)="onRowSelected($event)"
                [cypressControlIdentifier]="tableTitle" data-cy="select-dialog-table">
                <ng-container *ngFor="let item of columnDefinitions; index as index">
                    <tdo-table-column [displayName]="item[0]" [propertyName]="item[1]" [isSortable]="item[2]"
                        [rowTemplate]="column" data-cy="select-dialog-table-column">
                        <ng-template #column let-row>
                            {{row[item[1]]}}
                        </ng-template>
                    </tdo-table-column>
                </ng-container>
            </tdo-table>
        </div>
        <!--  FOOTER-->
        <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="select-dialog-footer">
            <div style="flex: 1; margin-right: 6px;"></div>
            <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="select-dialog-cancel-button">Cancel</button>
            <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="select-dialog-ok-button">Ok</button>
        </div>
    </div>
</div>